import { SweepsResponse } from '@/core/sweep';
import { getChainConstant } from '@/domain/chain';
import { SubgraphUrl } from '@/domain/subgraph';
import { useChain } from '@/hooks/useChain';
import querySubgraph from '@/infrastructure/subgraph';
import { useQuery } from '@tanstack/react-query';

const useSweeps = () => {
  const chain = useChain();
  return useQuery({
    queryKey: ['sweeps', chain.id],
    queryFn: async () => {
      const data = await querySubgraph<SweepsResponse>({
        url: getChainConstant(SubgraphUrl, chain.id),
        query: `query Sweeps {
        sweeps(where: { id_gt: 0 } orderBy:epoch__startTime, orderDirection: desc) {
          id # epoch
          sweptAt # sweep tx timestamp, null if not yet swept
          sweepSize
          transaction
          status
          epoch {
            sampleSize
            type # sweep war or new collection war
            collections {
              id # epoch-collection id
              votesFor
              votesAgainst
              collection {
                id
                name
                symbol
              }
            }
            newCollections {
              id # epoch-new-collection id
              votesFor
              collection {
                id
                symbol
              }
            }
          }
        }
      }`,
      });

      return data.sweeps;
    },
  });
};

export default useSweeps;
